// loanSearchProductSlice.js
import { createSlice } from '@reduxjs/toolkit';

const loanSearchProductSlice = createSlice({
  name: 'loanSearchProduct',
  initialState: {
    loanProduct: {},
    partnerDetails: {},
    rbackKey: '',
  },
  reducers: {
    setLoanProductValue: (state, action) => {
      state.loanProduct = action.payload;
    },
    setPartnerDetails: (state, action) => {
      state.partnerDetails = action.payload;
    },
    setRbackKey: (state, action) => {
      state.rbackKey = action.payload;
    },
    clearLoanProductValue: state => {
      state.loanProduct = {};
      state.rbackKey = '';
      state.partnerDetails = {};
    },
  },
});

export const { setLoanProductValue, clearLoanProductValue, setRbackKey, setPartnerDetails } =
  loanSearchProductSlice.actions;
export default loanSearchProductSlice.reducer;
